/* Beneficios da compra - carrinho.
   Os estados vem renderizados do servidor pelo snippet (sem flash, funciona sem JS).
   Este arquivo cuida do que exige comparar antes/depois ou disparar acao.

   Sao DOIS blocos independentes, cada um com seu [data-pe-box] e seu data-pe-tipo:
     "presente" - tres faixas EXCLUSIVAS entre si (leva um so)
     "projeto"  - soma ao presente a partir de R$ 15.000
   Tudo aqui e por BOX: o botao clicado diz em qual bloco agir. Cada bloco aparece duas vezes
   na pagina (gaveta e rodape do carrinho), entao nunca usar querySelector global pra agir.

   Mora no layout e usa delegacao no document: o drawer se re-renderiza por innerHTML e
   script inserido assim NUNCA executa. */
(function () {
  var SECOES = ['cart-drawer', 'cart-icon-bubble', 'main-cart-items', 'main-cart-footer'];
  var ocupado = false;
  /* marca a linha adicionada pelo componente. E o unico sinal confiavel de que AQUELE item
     entrou como brinde: quando o carrinho cai de faixa e o desconto some, sem isso a linha
     vira uma compra qualquer e o cliente e cobrado em silencio. '_' esconde do cliente. */
  var PROP = { _presente: '1' };
  var ultimoRender = {};

  function ler(box) {
    if (!box) return null;
    return {
      tipo: box.dataset.peTipo || 'presente',
      estado: box.dataset.peEstado,
      itens: box.dataset.peItens || '',
      falta: box.dataset.peFalta,
      nome: box.dataset.peNome || 'o presente',
      preco: box.dataset.pePreco || '',
      cheio: box.dataset.peCheio || '',
      desc: box.dataset.peDesc || '',
      key: box.dataset.peKey || '',
      trocaKey: box.dataset.peTrocaKey || '',
      qtd: parseInt(box.dataset.peQtd || '0', 10),
      variante: box.dataset.peVar || '0',
      /* faixa paga (Projeto, R$ 690) x presente (R$ 0): muda so o texto.
         Le os CENTAVOS, nunca o texto formatado - "R$ 0,00" vira "000" e daria positivo. */
      pago: (parseInt(box.dataset.pePrecoCent || '0', 10) || 0) > 0
    };
  }

  function mapa(str) {
    var m = {};
    (str || '').split(',').forEach(function (p) {
      if (!p) return;
      var kv = p.split(':');
      if (kv.length === 2) m[kv[0]] = parseInt(kv[1], 10);
    });
    return m;
  }



  /* atualiza as mesmas secoes que o tema atualiza */
  function recarregar() {
    var url = location.pathname + '?sections=' + SECOES.join(',');
    return fetch(url, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) { return r.json(); })
      .then(function (j) {
        var dp = new DOMParser();
        var pares = [
          ['#CartDrawer', '#CartDrawer'],
          ['#cart-icon-bubble', '#cart-icon-bubble'],
          ['#main-cart-items .js-contents', '#main-cart-items .js-contents'],
          ['#main-cart-footer .js-contents', '#main-cart-footer .js-contents'],
          ['#main-cart-footer', '#main-cart-footer']
        ];
        Object.keys(j).forEach(function (id) {
          var doc = dp.parseFromString(j[id], 'text/html');
          pares.forEach(function (p) {
            var alvo = document.querySelector(p[0]);
            var novo = doc.querySelector(p[1]);
            if (alvo && novo && alvo.innerHTML !== novo.innerHTML) alvo.innerHTML = novo.innerHTML;
          });
        });
        if (typeof publish === 'function') publish('cart-update', { source: 'projeto-essencia' });
      })
      .catch(function () { location.reload(); });
  }

  function post(rota, corpo) {
    return fetch(rota, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(corpo)
    }).then(function (r) { return r.json(); });
  }

  function solta(bt) { ocupado = false; if (bt) bt.disabled = false; }

  function adicionar(box, bt) {
    if (ocupado) return;
    var e = ler(box);
    if (!e || !e.variante || e.variante === '0') return;
    ocupado = true;
    if (bt) bt.disabled = true;
    post('/cart/add.js', { items: [{ id: parseInt(e.variante, 10), quantity: 1, properties: PROP }] })
      .then(recarregar)
      .then(function () { ocupado = false; })
      .catch(function () { solta(bt); });
  }

  function remover(box) {
    if (ocupado) return;
    var e = ler(box);
    if (!e || !e.key) return;
    ocupado = true;
    post('/cart/change.js', { id: e.key, quantity: 0 })
      .then(recarregar)
      .then(function () { ocupado = false; })
      .catch(function () { ocupado = false; });
  }

  /* Troca: as tres faixas de presente sao exclusivas. Tira o presente da faixa antiga e poe o
     da faixa atual. Remove ANTES de adicionar, pra nunca existirem dois no carrinho. */
  function trocar(box, bt) {
    if (ocupado) return;
    var e = ler(box);
    if (!e || !e.trocaKey || !e.variante || e.variante === '0') return;
    ocupado = true;
    if (bt) bt.disabled = true;
    post('/cart/change.js', { id: e.trocaKey, quantity: 0 })
      .then(function () { return post('/cart/add.js', { items: [{ id: parseInt(e.variante, 10), quantity: 1, properties: PROP }] }); })
      .then(recarregar)
      .then(function () { ocupado = false; })
      .catch(function () { solta(bt); });
  }

  /* ---- popup da escolha do presente --------------------------------------
     MOVER PRO <body> ao abrir e obrigatorio: a gaveta do carrinho tem transform
     (translateX), e transform num ancestral vira o bloco de contencao de position:fixed —
     o popup ficaria preso e cortado dentro da gaveta. */
  function modalDe(box) {
    var w = box.closest('.pe-wrap');
    var m = w ? w.querySelector('[data-pe-modal]') : null;
    return m || document.querySelector('[data-pe-modal]');
  }
  function abrirModal(box) {
    var m = modalDe(box);
    if (!m) return;
    if (m.parentElement !== document.body) document.body.appendChild(m);
    m.hidden = false;
    m.setAttribute('aria-hidden', 'false');
    document.documentElement.style.overflow = 'hidden';
    var primeiro = m.querySelector('[data-pe-escolha]');
    if (primeiro) primeiro.focus();
  }
  function fecharModal() {
    [].forEach.call(document.querySelectorAll('[data-pe-modal]'), function (m) {
      m.hidden = true;
      m.setAttribute('aria-hidden', 'true');
    });
    document.documentElement.style.overflow = '';
  }
  /* Escolher NEM SEMPRE e trocar. Quem manda e data-pe-troca-key, que o Liquid so preenche
     quando ha algo a substituir (estado T, ou "trocar de presente" no E). Nos estados C e P
     ele vem vazio: a faixa 3 da DOIS presentes, e completar a cota nao pode remover o que o
     cliente ja escolheu. */
  function escolher(variante, bt) {
    if (ocupado) return;
    var box = document.querySelector('[data-pe-box]');
    var antiga = box ? (box.dataset.peTrocaKey || '') : '';
    ocupado = true;
    if (bt) bt.disabled = true;
    var p = Promise.resolve();
    if (antiga) p = p.then(function () { return post('/cart/change.js', { id: antiga, quantity: 0 }); });
    p.then(function () { return post('/cart/add.js', { items: [{ id: parseInt(variante, 10), quantity: 1, properties: PROP }] }); })
      .then(function () { fecharModal(); return recarregar(); })
      .then(function () { ocupado = false; })
      .catch(function () { solta(bt); });
  }

  /* ---- minimizar / exibir -------------------------------------------------
     Guardado por TIPO de bloco, nao por elemento: o mesmo bloco aparece na gaveta e no
     rodape, e os dois tem que concordar. E precisa ser reaplicado a cada render, porque o
     drawer troca o innerHTML e leva a classe embora. */
  /* Minimizar vale SO enquanto a mensagem for a mesma. Se o estado do bloco muda (ganhou o
     presente, perdeu o desconto, subiu de faixa), ha novidade pra mostrar e ele reabre
     sozinho — senao o cliente minimiza uma vez e nunca mais ve um alerta.
     Por isso o estado vai guardado JUNTO com a flag: '1|<estado>'.

     DUAS REGRAS que custaram um bug: (1) a decisao e por TIPO, nunca por caixa — o mesmo
     bloco existe na gaveta E no rodape, e se uma instancia estiver com data-pe-estado
     diferente da outra ela invalidaria a flag que a outra acabou de gravar, desfazendo o
     clique sozinho; (2) NUNCA escrever no storage durante a pintura, so no clique. */
  function estadoCanonico(tipo) {
    var b = document.querySelector('[data-pe-box][data-pe-tipo="' + tipo + '"]');
    return b ? (b.dataset.peEstado || '') : '';
  }
  function minimizado(tipo) {
    try {
      var v = localStorage.getItem('pe_min_' + tipo);
      if (!v) return false;
      var p = v.split('|');
      if (p[0] !== '1') return false;
      return p[1] === estadoCanonico(tipo);
    } catch (x) { return false; }
  }
  function guardarMin(tipo, v) {
    try {
      if (v) localStorage.setItem('pe_min_' + tipo, '1|' + estadoCanonico(tipo));
      else localStorage.removeItem('pe_min_' + tipo);
    } catch (x) {}
  }
  function pintarMin() {
    var cache = {};
    [].forEach.call(document.querySelectorAll('[data-pe-box]'), function (b) {
      var tipo = b.dataset.peTipo || 'presente';
      if (!(tipo in cache)) cache[tipo] = minimizado(tipo);
      var min = cache[tipo];
      b.classList.toggle('pe-box--min', min);
      /* dispensado = clicou em "Manter o atual" neste mesmo estado */
      b.classList.toggle('pe-box--fora', dispensado(b));
      var bt = b.querySelector('[data-pe-toggle]');
      if (bt) {
        var exp = min ? 'false' : 'true';
        var rot = min ? 'Exibir' : 'Minimizar';
        /* so escrever se mudou: setAttribute com valor igual ainda dispara o
           MutationObserver, que chama avaliar(), que chama pintarMin() de novo */
        if (bt.getAttribute('aria-expanded') !== exp) bt.setAttribute('aria-expanded', exp);
        if (bt.getAttribute('aria-label') !== rot) bt.setAttribute('aria-label', rot);
        if (bt.getAttribute('title') !== rot) bt.setAttribute('title', rot);
      }
    });
  }
  /* "Manter o atual": o cliente subiu de faixa mas prefere o beneficio que ja tem. Guardo a
     dispensa junto com o ESTADO e os itens — quando o carrinho muda, a oferta volta sozinha.
     O Liquid nao le localStorage, entao quem esconde e o JS, dentro de pintarMin(). */
  function dispensado(box) {
    try {
      var v = localStorage.getItem('pe_dispensa');
      return !!v && v === (box.dataset.peEstado + '|' + box.dataset.peItens);
    } catch (x) { return false; }
  }
  function dispensar(box) {
    try { localStorage.setItem('pe_dispensa', box.dataset.peEstado + '|' + box.dataset.peItens); } catch (x) {}
    pintarMin();
  }

  function alternarMin(box) {
    var tipo = box.dataset.peTipo || 'presente';
    guardarMin(tipo, !minimizado(tipo));
    pintarMin();
  }

  function avaliar() {
    pintarMin();
    /* um bloco por tipo: ele aparece na gaveta E no rodape, e os dois sao iguais */
    var vistos = {};
    var caixas = [];
    [].forEach.call(document.querySelectorAll('[data-pe-box]'), function (b) {
      var t = b.dataset.peTipo || 'presente';
      if (vistos[t]) return;
      vistos[t] = true;
      caixas.push(b);
    });

    for (var i = 0; i < caixas.length; i++) {
      var box = caixas[i];
      var e = ler(box);
      if (!e) continue;
      var assinatura = e.estado + '|' + e.itens;
      if (ultimoRender[e.tipo] === assinatura) continue;
      ultimoRender[e.tipo] = assinatura;

      /* trava de 1 unidade: dois do mesmo beneficio nao fazem sentido, e so o primeiro
         ganha o desconto */
      if (e.qtd > 1 && e.key && !ocupado) {
        ocupado = true;
        post('/cart/change.js', { id: e.key, quantity: 1 })
          .then(recarregar)
          .then(function () { ocupado = false; });
        return;
      }

    }
  }

  document.addEventListener('click', function (ev) {
    if (!ev.target.closest) return;

    /* a LINHA DO TITULO inteira alterna, nao so o icone de 24px: alvo maior, e se algum
       overlay de app cobrir o cantinho do icone o cliente ainda consegue fechar/abrir */
    var cab = ev.target.closest('.pe-t');
    if (cab && !ev.target.closest('[data-pe-modal]')) {
      var cx = cab.closest('[data-pe-box]');
      if (cx) { ev.preventDefault(); return alternarMin(cx); }
    }

    var bt = ev.target.closest('[data-pe-toggle],[data-pe-add],[data-pe-remove],[data-pe-swap],[data-pe-acao],[data-pe-escolher],[data-pe-fechar],[data-pe-escolha],[data-pe-manter]');
    if (!bt) return;
    var box = bt.closest('[data-pe-box]') || document.querySelector('[data-pe-box]');
    if (!box) return;
    ev.preventDefault();
    if (bt.hasAttribute('data-pe-toggle')) return alternarMin(box);
    if (bt.hasAttribute('data-pe-escolher')) return abrirModal(box);
    if (bt.hasAttribute('data-pe-fechar')) return fecharModal();
    if (bt.hasAttribute('data-pe-escolha')) return escolher(bt.dataset.peEscolha, bt);
    if (bt.hasAttribute('data-pe-manter')) return dispensar(box);
    if (bt.hasAttribute('data-pe-add')) return adicionar(box, bt);
    if (bt.hasAttribute('data-pe-remove')) return remover(box);
    if (bt.hasAttribute('data-pe-swap')) return trocar(box, bt);
    var acao = bt.dataset.peAcao;
    if (acao === 'add') return adicionar(box, bt);
    if (acao === 'remove') return remover(box);
  });

  document.addEventListener('keydown', function (ev) {
    if (ev.key === 'Escape') fecharModal();
  });

  if (typeof subscribe === 'function') {
    subscribe('cart-update', function () { setTimeout(avaliar, 80); });
  }
  new MutationObserver(function () { avaliar(); })
    .observe(document.documentElement, { childList: true, subtree: true });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', avaliar);
  else avaliar();
})();
